import { BIM360IssueComment } from '../BIM360IssueComment';

export class FrontendBIM360IssueComment {
    issue_id: string = "";
    body: string = "";
}
